<template>
    <view>
        <div class="header">
            <div class="tips">
                <ul>
                    <li>金沙江畔 水韵巧家！{{ getFormattedDate() }}</li>
                    <li class="image-container">
                        
                        <div class="trigger">
                            <i class="iconfont icon-shouji2" style="font-size:20px"></i>巧家融媒客户端
                            <div class="hidden-image"><img src="../assets/images/app.png" title="巧家融媒客户端"></div>
                        </div>&nbsp;&nbsp;&nbsp;
                        <div class="trigger">
                            <i class="iconfont icon-weixin5" style="font-size:25px"></i>微信
                            <div class="hidden-image"><img src="../assets/images/weixincode.jpg" title="巧家融媒微信公众号"></div>
                        </div>&nbsp;&nbsp;&nbsp;
                        <a href="https://weibo.com/qjxnews?tabtype=home" target="_blank"><i class="iconfont icon-xinlangweibo" style="font-size:25px"></i>微博</a>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div class="trigger">
                            <i class="iconfont icon-douyin2" style="font-size:25px"></i>抖音号
                            <div class="hidden-image"><img src="../assets/images/douyincode.jpg" title="巧家融媒抖音"></div>
                        </div>&nbsp;&nbsp;&nbsp;
                        <div class="trigger">
                            <i class="iconfont icon-kuaishou1" style="font-size:25px"></i>快手号
                            <div class="hidden-image"><img src="../assets/images/kuais.jpg" title="巧家融媒快手号"></div>
                        </div>&nbsp;&nbsp;&nbsp;
                        <div class="trigger">
                            <i class="iconfont icon-shipinhao1" style="font-size:25px"></i>视频号
                            <div class="hidden-image"><img src="../assets/images/shipinhao.jpg" title="巧家融媒视频号"></div>
                        </div>
                    </li>
                    <li>
                        <div class="input-group search">
                            <input type="text" class="form-control searchinput" placeholder="内容关键词" id="search" name="search" v-model="searchKeyword" >
                            <button class="input-group-text onsearch" @click="handleSearchClick"><i class="iconfont icon-sousuo1"></i></button>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="top">
                <div class="logo"><router-link to="/index"><img src="../assets/images/site_logo.png"></router-link></div>
                <div class="menu">
                    <ul>
                        <li class="menu_a">
                            <router-link to="/index">首页</router-link>
                            <router-link to="/article/show-89606.html" target="_blank">县情</router-link>
                            <router-link to="/list_70.html" target="_blank">要闻</router-link>
                            <router-link to="/zhengwu.html" target="_blank">政务</router-link>
                            <br>
                            <router-link to="/list_72.html" target="_blank">乡镇</router-link>
                            <router-link to="/list_73.html" target="_blank">部门</router-link>
                            <router-link to="/zhuanti/index.html" target="_blank">专题</router-link>
                            <router-link to="/list_82.html" target="_blank">图片</router-link>
                        </li>
                        <li class="menu_a">
                            <router-link to="/list_90.html" target="_blank">领导活动</router-link>
                            <router-link to="/list_87.html" target="_blank">社会民生</router-link>
                            <router-link to="/list_79.html" target="_blank">通知公告</router-link>
                            <br>
                            <router-link to="/list_80.html" target="_blank">视听巧家</router-link>
                            <router-link to="/list_81.html" target="_blank">媒体关注</router-link>
                            <router-link to="/list_77.html" target="_blank">国内新闻</router-link>
                        </li>
                        <li class="menu_a">
                            <router-link to="/list_92.html" target="_blank">政策解读</router-link>
                            <router-link to="/list_91.html" target="_blank">理论调研</router-link>
                            <router-link to="/zhuanti/node_368223.html" target="_blank">健康巧家</router-link>
                            <br>
                            <router-link to="/list_78.html" target="_blank">文化旅游</router-link>
                            <router-link to="/list_88.html" target="_blank">平安巧家</router-link>
                            <router-link to="/list_86.html" target="_blank">文明巧家</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="mobile_header">
            <div class="mobile_logo"><router-link to="/index"><img src="../assets/images/site_logo.png"></router-link></div>
            <div class="mobile_menu">
                <button class="btn btn-outline-light" type="button" style="color:#999999" data-bs-toggle="offcanvas" data-bs-target="#myOffcanvas" aria-controls="myOffcanvas">
                    <i class="fa fa-reorder">&nbsp;</i>导航
                </button>
            </div>
            <div style="clear:both"></div>
        </div>
        <!-- HTML 结构 -->  
        <div class="offcanvas offcanvas-start" tabindex="-1" id="myOffcanvas" aria-labelledby="myOffcanvasLabel">
            <div class="offcanvas-header">  
                <h5 class="offcanvas-title" id="myOffcanvasLabel">新闻栏目</h5>  
                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>  
            </div>  
            <div class="offcanvas-body">  
                <div class="mobile_menu_type">
                    <ul>
                        <li>
                            <div><router-link to="/index">首页</router-link></div>
                            <div><router-link to="/article/show-89606.html">县情</router-link></div>
                            <div><router-link to="/list_70.html">要闻</router-link></div>
                            <div><router-link to="/zhengwu.html">政务</router-link></div>
                            <div><router-link to="/list_72.html">乡镇</router-link></div>
                            <div><router-link to="/list_73.html">部门</router-link></div>
                            <div><router-link to="/zhuanti/index.html">专题</router-link></div>
                            <div><router-link to="/list_82.html">图片</router-link></div>
                            <div style="display:none;clear:both" target="_blank"></div>
                        </li>
                        <li>
                            <div><router-link to="/list_90.html">领导活动</router-link></div>
                            <div><router-link to="/list_87.html">社会民生</router-link></div>
                            <div><router-link to="/list_79.html">通知公告</router-link></div>
                            <div><router-link to="/list_80.html">视听巧家</router-link></div>
                            <div><router-link to="/list_81.html">媒体关注</router-link></div>
                            <div><router-link to="/list_77.html">国内新闻</router-link></div>
                            <div style="display:none;clear:both"></div>
                        </li>
                        <li>
                            <div><router-link to="/list_92.html">政策解读</router-link></div>
                            <div><router-link to="/list_91.html">理论调研</router-link></div>
                            <div><router-link to="/zhuanti/node_368223.html">健康巧家</router-link></div>
                            <div><router-link to="/list_78.html">文化旅游</router-link></div>
                            <div><router-link to="/list_88.html">平安巧家</router-link></div>
                            <div><router-link to="/list_86.html">文明巧家</router-link></div>
                            <div style="display:none;clear:both"></div>
                        </li>
                    </ul>
                </div>
            </div>  
        </div>  
        <div class="show_tip_toast" v-show="toastShow">
            {{toastText}}
        </div>
    </view>
</template>
<script>
    export default {
        name: 'HeaderPage',
        data() {
            return {
                toastShow: false,
                toastText: '',
                searchKeyword: ''
            }
        },
        created() {
        },
        methods: {
            getFormattedDate() {  
                const date = new Date();  
                const year = date.getFullYear();  
                const month = this.padZero(date.getMonth() + 1); // 月份是从0开始的，所以要加1  
                const day = this.padZero(date.getDate());  
                const weekDay = this.getWeekDay(date.getDay());  
            
                return `${year}年${month}月${day}日 ${weekDay}`;  
            },  
            padZero(num) {  
                // 在小于10的数字前补零  
                return num < 10 ? `${num}` : num;  
            },  
            getWeekDay(dayIndex) {  
                // 获取星期几，并转换为中文  
                const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];  
                return weekDays[dayIndex];  
            },  
            handleSearchClick() {  
                if (this.searchKeyword.trim() === '') {  
                    // 输入为空，提示用户
                    this.toast('请输入关键词')  
                } else {  
                    // 输入不为空，跳转到search.vue页面并传递关键词  
                    this.$router.push({ name: 'search', query: { keyword: this.searchKeyword } });  
                }  
            },
            toast (str) {
                let v = this
                v.toastText = str
                v.toastShow = true
                setTimeout(function(){
                    v.toastShow = false
                }, 2500)
            } 
        },
    }
</script>
  